import styled, { css } from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 48px;
`;

export const Subtitle = styled.div`
  color: #bb8b2b;
  font-family: "YWFT Ultramagnetic";
  font-size: 22px;
  text-align: center;
  text-transform: uppercase;
`;

export const Title = styled.div`
  margin-top: 12px;
  font-family: "YWFT Ultramagnetic";
  font-size: 30px;
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;
`;
